module.exports = __webpack_public_path__ + "static/media/google-play-badge.4263a06f.png";